// The basics
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Route } from 'react-router';
import PropTypes from 'prop-types';
import { AnimatedLogo } from '@experian-uk/corvetteuk-common-ui';

// Action creators and helpers
import establishCurrentUser from './actions/auth/establishCurrentUser';
import initializeEcd from './actions/ecd/initialize';
import { applicationStarted } from './reducers/app';

import { FullPageContainer } from './components/Container';
import Routes from './pages';

const PAGE_TITLES = {
  '/': 'Experian - Subscriptions',
  '/chooser': 'Experian - Choose a Plan',
  '/chooser/restart': 'Experian - Choose a Plan',
  '/switch': 'Experian - Subscriptions',
  '/thanks': 'Experian - Thank You',
  '/billing': 'Experian - Payment & Billing',
  '/billing/change-date': 'Experian - Change Billing Date',
  '/confirm': 'Experian - Confirm',
  '/our-products': 'Experian - Our Products',
  '/deactivate': 'Experian - Deactivate Account',
  '/activation': 'Experian - Activation',
  '/error': 'Experian - Error',
  '/acquisition': 'Experian - Acquisition',
  '/challenge-finished': 'Experian - Challenge Finished',
};

export const getPageTitle = pathname => {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
  const matchedKey = Object.keys(PAGE_TITLES)
    .filter(key => key !== '/' && pathname.startsWith(key))
    .sort((a, b) => b.length - a.length)[0];
  return matchedKey ? PAGE_TITLES[matchedKey] : 'Experian - Subscriptions';
};

@withRouter
@connect(
  state => ({
    hasAppStarted: state.app.hasStarted,
  }),
  dispatch =>
    bindActionCreators(
      {
        initializeEcd,
        establishCurrentUser,
        applicationStarted,
      },
      dispatch
    )
)
export default class App extends Component {
  static propTypes = {
    applicationStarted: PropTypes.func.isRequired,
    initializeEcd: PropTypes.func.isRequired,
    establishCurrentUser: PropTypes.func,
    hasAppStarted: PropTypes.bool.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  };

  static defaultProps = {
    establishCurrentUser: () => {},
    location: {
      pathname: '',
    },
  };

  componentDidMount() {
    void this.initializeApp();
    document.title = getPageTitle(this.props.location.pathname);
  }

  initializeApp = async () => {
    try {
      await Promise.all([this.props.establishCurrentUser(), this.props.applicationStarted()]);
      this.props.initializeEcd();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('App initialization failed', error);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      document.title = getPageTitle(this.props.location.pathname);
    }
  }

  render() {
    return (
      <div id="app">
        {this.props.hasAppStarted ? (
          <Routes />
        ) : (
          <Route>
            <FullPageContainer>
              <AnimatedLogo />
            </FullPageContainer>
          </Route>
        )}
      </div>
    );
  }
}
